
export type ExportMetricsBodyFormat = typeof ExportMetricsBodyFormat[keyof typeof ExportMetricsBodyFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportMetricsBodyFormat = {
  CSV: 'CSV',
  JSON: 'JSON',
  PDF: 'PDF',
} as const;
